<template>
    <b-container v-if="tour_prop" fluid class="w-100 card_body">
        <b-row>
            <b-col><h3>Tour:&nbsp;{{ tour_prop.title }}</h3></b-col>
        </b-row>
        <b-row>
            <b-col><hr></b-col>
        </b-row>
        <b-row class="w-100">
            <b-col><h5><b-icon-calendar></b-icon-calendar>&nbsp;{{ format_data }}</h5></b-col>
        </b-row>
        <b-row>
            <b-col><hr></b-col>
        </b-row>
        <b-row no-gutters>
            <b-col><h6><b-icon-tag></b-icon-tag>:{{ tour_prop.available_seats}}&nbsp;/&nbsp;{{ tour_prop.occupancy}}</h6></b-col>
            <b-col><h6><b-icon-person></b-icon-person>:&nbsp;1 </h6></b-col>
            <b-col><h6><b-icon-flag></b-icon-flag>:&nbsp;{{ tour_prop.tour.Language }}</h6></b-col>
            <b-col><h6>{{tour_prop.tour.price | formatCurrency}}</h6></b-col>
        </b-row>
        <b-row>
            <b-col><hr></b-col>
        </b-row>
        <b-row>
            <b-col sm="5">
                <b-input-group v-if="hasBuyListener">
                    <b-button v-if="isBuyable" @click="$emit('buy', tour_prop.ID)" variant="success">{{localized_text[lang].buy}}</b-button>
                    <b-button v-else disabled>{{localized_text[lang].notavail}}</b-button>
                </b-input-group>
                <b-input-group v-if="hasHostListener">
                    <b-button  @click="$emit('host', tour_prop.ID)" variant="success">{{localized_text[lang].start}}</b-button>
                </b-input-group>
            </b-col>
            <b-col sm="7">
                <div style="font-size: small">{{localized_text[lang].timenote}}</div>
            </b-col>
        </b-row>

    </b-container>
    <b-container v-else fluid class="card_body">
        <b-row no-gutters class="h-100">
            <b-col style="margin:auto;">
                <h4>{{localized_text[lang].info}}</h4>
            </b-col>
        </b-row>
    </b-container>

</template>

<script>
    import moment from 'moment'
    moment.locale('IT');

    export default {
        name: "EventCard",
        props: ['tour_prop', 'lang'],
        data (){
            return {
                localized_text:{
                    IT:{buy:'Acquista', start:'Avvia', notavail:'Non disponibile', info:'Seleziona un tour dal calendario per acquistarlo', timenote:'Il biglietto può essere acquistato fino a 5 minuti prima dell\'inizio del tour'},
                    EN:{buy:'Buy', start:'Start', notavail:'Not available', info:'Select a tour from the calendar to buy it', timenote:'Ticket can be bougth till 5 minutes from the start of the tour'}
                }
            }
        },
        computed: {
            // get only
            format_data: function () {
                return new moment(this.tour_prop.start).format('LLL');
            },
            hasBuyListener(){
                return this.$listeners && this.$listeners.buy;
            },
            hasHostListener(){
                return this.$listeners && this.$listeners.host;
            },
            isBuyable() {
                let isfuture = new moment(this.tour_prop.start).diff(moment(), 'minutes') > 5;
                return (this.tour_prop.available_seats > 0) && isfuture;
            }
        },
        filters:{
            formatCurrency: function (_value) {
                let formatter = new Intl.NumberFormat('it-IT', {
                    style: 'currency',
                    currency: 'EUR',
                });
                return formatter.format((_value / 100));
            }
        },
    }
</script>

<style scoped>

    .card_body{
        /*background-color: #ffda9c;*/
        background: rgb(255,233,161);
        background: linear-gradient(150deg, rgba(255,233,161,1) 34%, rgba(255,215,65,1) 100%);
        height:260px;
        min-height:250px;
        padding:15px 5px 0 5px;
    }

    @media screen and (max-width: 400px) {

        .card_body {
            height:210px;
            min-height:210px;
        }

        h3 {
            font-size: 1.5em;
        }

        h4 {
            font-size: 1.2em;
        }

        h6 {
            font-size: 0.9em;
        }

        hr {
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        }
    }

</style>
